export default {
  titleHeader(state) {
    return state.titleHeader;
  }
};
